import * as qs from 'qs';
import { API_ROOT_PATH } from './Constants';

export const fetchData = (url: string, params?: Record<string, any>) =>
    fetch(`${API_ROOT_PATH}${url}${params ? `?${qs.stringify(params)}` : ''}`)
        .then(x => x.json())
        .catch(err => console.error(err));
